import gql from 'graphql-tag'

export const deleteAllQuery = (folders, podcasts) => {
  const variables = []
  const values = {}
  const queries = []

  folders.forEach((folder, index) => {
    const name = `folder_${index}`
    variables.push(`$${name}: ID!`)
    values[name] = folder
    queries.push(`
      folder_${index}: deleteFolder(
        id: $${name},
      ) {
        _id
      }
    `)
  })

  podcasts.forEach((podcast, index) => {
    const name = `podcast_${index}`
    variables.push(`$${name}: ID!`)
    values[name] = podcast
    queries.push(`
      podcast_${index}: deletePodcast(
        id: $${name},
      ) {
        _id
      }
    `)
  })

  return {
    mutation: gql`
      mutation (${variables.join(', ')}) {
        \t${queries.join('\n')} 
      }
    `,
    variables: values,
  }
}

export const moveToFolderQuery = (folders, podcasts, targetId) => {
  const variables = []
  const values = {}
  const queries = []

  folders.forEach((folder, index) => {
    const name = `id_folder_${index}`
    const data = `data_folder_${index}`
    variables.push(`$${name}: ID!, $${data}: PartialUpdateFolderInput!`)
    values[name] = folder
    values[data] = {
      parent: {
        connect: targetId,
      },
    }
    queries.push(`
      folder_${index}: partialUpdateFolder(
        id: $${name},
        data: $${data}
      ) {
        _id
        _ts
        name
      }
    `)
  })

  podcasts.forEach((podcast, index) => {
    const name = `id_podcast_${index}`
    const data = `data_podcast_${index}`
    variables.push(`$${name}: ID!, $${data}: PartialUpdatePodcastInput!`)
    values[name] = podcast
    values[data] = {
      folder: {
        connect: targetId,
      },
    }
    queries.push(`
      podcast_${index}: partialUpdatePodcast(
        id: $${name},
        data: $${data}
      ) {
        _id
        _ts
        name
        publishedAt
      }
    `)
  })

  return {
    mutation: gql`
      mutation (${variables.join(', ')}) {
        \t${queries.join('\n')} 
      }
    `,
    variables: values,
  }
}
